export const calculatorOutline = (props) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7 2H17C18.6569 2 20 3.34315 20 5V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V5C4 3.34315 5.34315 2 7 2ZM6 5C6 4.44772 6.44772 4 7 4H17C17.5523 4 18 4.44772 18 5V19C18 19.5523 17.5523 20 17 20H7C6.44772 20 6 19.5523 6 19V5Z'
        fill='#023F80'
      />
      <path
        d='M8 6.5H16C16.2761 6.5 16.5 6.72386 16.5 7V9C16.5 9.27614 16.2761 9.5 16 9.5H8C7.72386 9.5 7.5 9.27614 7.5 9V7C7.5 6.72386 7.72386 6.5 8 6.5Z'
        fill='#023F80'
      />
      <path d='M8.5 11.75H9.5C9.77614 11.75 10 11.9739 10 12.25V13.25C10 13.5261 9.77614 13.75 9.5 13.75H8.5C8.22386 13.75 8 13.5261 8 13.25V12.25C8 11.9739 8.22386 11.75 8.5 11.75Z' fill='#023F80' />
      <path d='M11.5 11.75H12.5C12.7761 11.75 13 11.9739 13 12.25V13.25C13 13.5261 12.7761 13.75 12.5 13.75H11.5C11.2239 13.75 11 13.5261 11 13.25V12.25C11 11.9739 11.2239 11.75 11.5 11.75Z' fill='#023F80' />
      <path d='M14.5 11.75H15.5C15.7761 11.75 16 11.9739 16 12.25V13.25C16 13.5261 15.7761 13.75 15.5 13.75H14.5C14.2239 13.75 14 13.5261 14 13.25V12.25C14 11.9739 14.2239 11.75 14.5 11.75Z' fill='#023F80' />
      <path d='M8.5 15.5H9.5C9.77614 15.5 10 15.7239 10 16V17C10 17.2761 9.77614 17.5 9.5 17.5H8.5C8.22386 17.5 8 17.2761 8 17V16C8 15.7239 8.22386 15.5 8.5 15.5Z' fill='#023F80' />
      <path d='M11.5 15.5H12.5C12.7761 15.5 13 15.7239 13 16V17C13 17.2761 12.7761 17.5 12.5 17.5H11.5C11.2239 17.5 11 17.2761 11 17V16C11 15.7239 11.2239 15.5 11.5 15.5Z' fill='#023F80' />
      <path d='M14.5 15.5H15.5C15.7761 15.5 16 15.7239 16 16V17C16 17.2761 15.7761 17.5 15.5 17.5H14.5C14.2239 17.5 14 17.2761 14 17V16C14 15.7239 14.2239 15.5 14.5 15.5Z' fill='#023F80' />
    </svg>
  );
};
